<template>
  <div ref="menu-content" class="home search-box" :class="getIsMobile ? '' : 'menu-content'">
    <!-- 顶部导航-自定义功能入口 H5 -->
    <topNavigation v-if="hasTopNavigation" />
    <!-- TG 全屏显示 的功能入口 -->
    <tgAction v-if="isLogin && isInTelegramWebApp" />
    <!-- PC 品宣 -->
    <brandPub v-if="!getIsMobile" />
    <!-- H5 品宣 -->
    <brandPubH5 v-if="getIsMobile" />

    <PopupDialog
      ref="PopupDialog"
      width="450px"
      :dataOpt="{ title: $t('Datalang.Newscenter_TITLE_annoncement') }"
      :show.sync="showEventModal"
      :class="getIsMobile ? 'topAuto' : ''"
      @close="close"
    >
      <template #center>
        <div class="event-modal_box">
          <EventModal :list="list" @close="close" />
          <div class="radio">
            <el-checkbox v-model="showToDay" :label="true" @change="onRadioChange">
              {{ $t("Datalang.VIP_TIP_todaynolongershows") }}
            </el-checkbox>
          </div>
          <div class="displayPromoteUrlDom" v-if="displayPromoteUrl">
            <span class="invitaTxt">{{ $t("Datalang.home_invite_play") }}</span>
            <el-button class="invitaBtn" size="medium" @click="goShare(item)">{{
              $t("Datalang.Invite_BTM_invitation")
            }}</el-button>
          </div>
        </div>
      </template>
    </PopupDialog>
    <PopupDialog
      ref="activityDialog"
      width="800px"
      :dataOpt="{}"
      :class="getIsMobile ? 'home-activity-dialog topAuto' : 'home-activity-dialog'"
      :top="getIsMobile ? '' : '20vh'"
      :show.sync="showActivityDialog"
      @close="closeActivityDialog"
    >
      <template #center>
        <div class="event-modal_box">
          <ActivityModal :list="activityList" @close="closeActivityDialog" />
        </div>
        <div class="displayPromoteUrlDom" v-if="displayPromoteUrl">
          <span class="invitaTxt">{{ $t("Datalang.home_invite_play") }}</span>
          <el-button class="invitaBtn" size="medium" @click="goShare(item)">{{
            $t("Datalang.Invite_BTM_invitation")
          }}</el-button>
        </div>
      </template>
    </PopupDialog>

    <!-- 悬浮提示栏 -->
    <div
      v-if="showFloating"
      class="floatingBar"
      :style="{
        top: headerHeight,
      }"
    >
      <span v-html="txtObj.txt0"></span>
      <div class="floatingBarRight">
        <span @click="showFloating = false" data-v-65052497="" class="floatingBarClose el-icon-close"></span>
        <div class="timeDown">{{ txtObj.timeDown }}</div>
        <el-button type="primary" size="mini" @click="showDialogFun">{{ $t("Datalang.newly_You_pay") }}</el-button>
      </div>
    </div>
    <PopupDialog
      width="400px"
      :dataOpt="{}"
      :top="'20vh'"
      :show.sync="showDialog"
      @close="handleCancal"
      class="tipDialog"
    >
      <template #center>
        <div class="txtMain">
          <div class="tipHead">
            <div class="relative">
              <img class="tipHeadImg" src="@/assets/home/tip-head.webp" alt="" />
              <div class="tipTitle">{{ txtObj.txt1 }}</div>
            </div>
          </div>
          <div class="tipContent">
            <img class="tipAmountImg" src="@/assets/home/tip-amount.webp" alt="" />
            <div>
              <div v-html="txtObj.txt2"></div>
            </div>
            <div class="times" v-if="tipType === '4' && Number(waitRechargeObj.freeTotalTimes) > 0">
              <img class="gameIcon" :src="$utils.returnImgUrl(waitRechargeObj.gameIconH5)" alt="" />
              <span class="num">&nbsp;&nbsp;&nbsp;&nbsp;X&nbsp;{{ waitRechargeObj.freeTotalTimes }}</span>
            </div>
            <div v-else v-html="txtObj.txt3"></div>
            <div v-html="txtObj.txt4"></div>
            <div v-html="txtObj.txt5"></div>
          </div>
        </div>
        <div class="btnDom" align="center">
          <el-button class="btn-unfinished" @click="handleCancal('btn')">{{ $t("Datalang.newly_Give_Up8") }}</el-button>
          <el-button type="primary" @click="handleConfirm">{{ $t("Datalang.newly_Continue_Payment") }}</el-button>
        </div>
      </template>
    </PopupDialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeLocalStorage, getLocalStorage } from "@/lobby_common/utils/auth.js";
import { setApiCache, formatLang, divideAccuracy } from "@/lobby_common/utils/utils";
import { getGameOtherInfo } from "@/lobby_common/api/game_gen.js";
import { getTemplateErJiPage, userVisit } from "@/lobby_common/api/basic_gen.js";
import topNavigation from "@/views/homeModule/topNavigation.vue";
import brandPub from "@/views/homeModule/brandPub.vue";
import brandPubH5 from "@/views/homeModule/brandPubH5.vue";
import tgAction from "@/views/homeModule/tgAction.vue";
import EventModal from "@/components/eventsModal/index.vue";
import ActivityModal from "@/components/homeActivityModal/index.vue";
import PopupDialog from "@/components/PopupDialog";
import { afPostRecharge } from "@/lobby_common/utils/utils.js";
// const brandPub = () => import("@/views/homeModule/brandPub.vue");
// const brandPubH5 = () => import("@/views/homeModule/brandPubH5.vue");
import { withdrawGuideShowText } from "@/lobby_common/api/user_gen.js";
import { useInactivityWatcher } from "@/lobby_common/utils/popTimer.js";
import { getWaitRechargeOrderDetail, userSecondRecharge } from "@/lobby_common/api/payment_gen.js";
export default {
  name: "Home",
  components: {
    brandPub,
    brandPubH5,
    EventModal,
    ActivityModal,
    PopupDialog,
    topNavigation,
    tgAction,
  },
  data() {
    return {
      divideAccuracy,
      gamedatalist: [],
      tab: "all",
      content: {},
      showEventModal: false,
      showToDay: false,
      eventTitle: null,
      list: [], // 活动公告图弹窗数据
      activityList: [], // 活动弹窗数据
      showActivityDialog: false,
      // isFixed: false,
      // topValue: undefined,
      cashData: {},
      firstScroll: "",
      firstScrollBottom: "",
      listenscroll: false,
      inactivity: null,
      showFloating: false,
      showDialog: false,
      tipType: "0",
      remainingSeconds: 30 * 60, // 30分钟倒计时
      remainingSeconds1: 1 * 60, // 30分钟倒计时
      timer: null,
      waitRechargeObj: {},
      confirmLoading: false, // 点击锁
    };
  },
  watch: {
    loginObj: {
      handler(val, oldVal) {
        oldVal = oldVal || {};
        const { isLogin, defaultCoinCode, after_quick, selectCoin } = val;
        // console.log(isLogin, defaultCoinCode, after_quick, selectCoin, "SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS");
        // if (isLogin && !defaultCoinCode && !after_quick) {
        //   // // 登录后并且未设置流通货币
        //   this.$isPopShow({
        //     show: true,
        //     views: "chooseCoin",
        //     data: {
        //       close: true,
        //       isChooseCoin: true,
        //     },
        //   });
        // }
        if (isLogin && oldVal.selectCoin === "" && selectCoin) {
          // 每日登录的公告轮播弹窗  系统没有维护的时候才弹
          if (!this.maintain || !this.maintain[0]) {
            // this.$popConfig.initWinConfig();
          }
        }

        if (isLogin && !after_quick && defaultCoinCode && oldVal.selectCoin === "" && selectCoin) {
          // 每日登录的公告轮播弹窗  系统没有维护的时候才弹
          if (!this.maintain || !this.maintain[0]) {
            this.$popConfig?.initWinConfig(1, true);
          }
        }
      },
      deep: true,
      immediate: true, // 刷新加载 立马触发一次handler
    },
  },
  async created() {
    // console.log("Home created");
    localStorage.removeItem("after_quick");

    // this.$Bus.$on("homeScrollTop", (opt) => {
    //   this.homeScrollTop(opt);
    // });
    this.$Bus.$on("showAnnouncementModal", (opt) => {
      this.showAnnouncementModal(opt);
    });
    this.$Bus.$on("showActivityModal", (opt) => {
      this.showActivityModal(opt);
    });
    // 隐藏公告弹窗
    this.$Bus.$on("hideNoticeModal", (opt) => {
      this.hideNoticeModal(opt);
    });
    // this.$Bus.$on("showPullNewModal", (opt) => {
    //   this.showPullNewModal(opt);
    // });
    // const { inviteCode } = this.$route.query;
    // if (inviteCode) {
    //   const arr = inviteCode?.split("?");
    //   const code = arr[0];
    //   setLocalStorage("inviteCode", code);
    // }
    // 获取上一笔订单
    this.$Bus.$on("getWaitRechargeOrderDetailWs", () => {
      this.getWaitRechargeOrderDetailFun();
    });
  },
  mounted() {
    this.initScroll();
    this.$nextTick(() => {
      const dom = this.$refs["menu-content"];
      if (!dom) return false;
      dom.animate(
        [
          {
            opacity: "1",
          },
        ],
        {
          duration: 1500, // 持续时间
          easing: "linear", // 规定动画的速度曲线
          delay: 1, // 在动画开始之前
          fill: "forwards", // 动画是否停在最后一个关键帧
        }
      );
    });
    setTimeout(() => {
      // 缓存二级菜单数据
      setApiCache("gameNavs", async () => {
        const res = await getGameOtherInfo({});
        if (res.code === 0) {
          const brandGroupList = res?.data?.brandGroupList || [];
          const brandGroupListKey = {};
          brandGroupList.map((item) => {
            brandGroupListKey[item.sid] = item;
          });
          const hotTagSid = (res.data?.tagList || []).find((e) => e.key === "hot")?.sid || "";
          const { data, code } = await getTemplateErJiPage();
          if (code === 0) {
            let list = [];
            let icons = [];
            try {
              list = JSON.parse(data.documentTabs) || [];
              icons = JSON.parse(data.gameBrandIcon) || [];
              const defaultAll = icons.find((item) => item.brandGroupSid === "-1");
              icons?.map((item) => {
                const { selectedIcon, unSelectedIcon } = item;
                if (brandGroupListKey[item.brandGroupSid]) {
                  if (defaultAll) {
                    brandGroupListKey[item.brandGroupSid].selectedIcon = defaultAll.selectedIcon;
                    brandGroupListKey[item.brandGroupSid].unSelectedIcon = defaultAll.unSelectedIcon;
                  }
                  if (selectedIcon) {
                    brandGroupListKey[item.brandGroupSid].selectedIcon = selectedIcon;
                  }
                  if (unSelectedIcon) {
                    brandGroupListKey[item.brandGroupSid].unSelectedIcon = unSelectedIcon;
                  }
                }
              });
            } catch (error) {
              console.log(error);
            }
            return {
              hotTagSid,
              list,
              brandGroupListKey,
            };
          }
        }
        return Promise.reject();
      });

      // 获取三方id
      const uniqueId = window.localStorage.getItem("uniqueId");
      if (uniqueId && !this.isLogin) {
        userVisit({
          uniqueId: uniqueId,
        });
      }
    }, 5000);
    if (this.isLogin) {
      this.getTipsStatus();
      // 红点
      this.$store.dispatch("getPointApi");
    }
    // this.startCountdown();
    if (!this.hasVisibilityListener) {
      document.addEventListener("visibilitychange", this.safeTriggerRechargeDetail);
      this.hasVisibilityListener = true;
    }
    setTimeout(() => {
      this.safeTriggerRechargeDetail();
    }, 2000);
  },
  beforeDestroy() {
    if (this.hasVisibilityListener) {
      document.removeEventListener("visibilitychange", this.safeTriggerRechargeDetail);
      this.hasVisibilityListener = false;
    }
    if (this.listenscroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }
    this.$Bus.$off("showAnnouncementModal");
    this.$Bus.$off("showActivityModal");
    this.$Bus.$off("hideNoticeModal");
    this.$Bus.$off("getWaitRechargeOrderDetailWs");
  },
  activated() {
    setTimeout(() => {
      this.safeTriggerRechargeDetail();
    }, 1500);

    if (this.inactivity) {
      this.inactivity.stop?.();
    }
    this.inactivity = useInactivityWatcher(
      () => {
        if (this.taken) {
          this.$popConfig?.initWinConfig(5);
        }
      },
      30000,
      this
    );
    // 看看有无存储af充值上报的
    afPostRecharge();

    // this.isFixed = false;
    if (this.listenscroll) {
      this.initScroll();
    }
  },
  deactivated() {
    if (this.listenscroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }
    if (this.inactivity) this.inactivity.stop();
    this.clearTimer();
  },
  computed: {
    ...mapGetters(["getIsMobile"]),
    headerHeight() {
      return this.$store.getters.getHeaderHeight;
    },
    txtObj() {
      let txt0 = "";
      let txt1 = "";
      let txt2 = "";
      let txt3 = "";
      let txt4 = "";
      let txt5 = "";
      switch (this.tipType) {
        case "1":
          txt0 = formatLang(this.$t("Datalang.newly_To_be2"), [
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount,
              this.userAccuracy
            )}</span>`,
          ]);
          txt1 = formatLang(this.$t("Datalang.newly_To_be2"), [
            `${this.userCoinSymbol} ${this.divideAccuracy(this.waitRechargeObj.activityAmount, this.userAccuracy)}`,
          ]);
          txt2 = formatLang(this.$t("Datalang.newly_Deposit8"), [
            `<span class="num">${this.chargeCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.money,
              this.userAccuracy
            )}</span>`,
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount,
              this.userAccuracy
            )}</span>`,
          ]);
          txt3 = formatLang(this.$t("Datalang.newly_After9"), [`<span class="num">${this.formattedTime}</span>`]);
          txt4 = this.$t("Datalang.newly_Expected_to5");
          break;
        case "2":
          txt0 = formatLang(this.$t("Datalang.newly_Extra9"), [
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount2,
              this.userAccuracy
            )}</span>`,
          ]);
          txt1 = formatLang(this.$t("Datalang.newly_Extra9"), [
            `${this.userCoinSymbol} ${this.divideAccuracy(this.waitRechargeObj.activityAmount2, this.userAccuracy)}`,
          ]);
          txt2 = formatLang(this.$t("Datalang.newly_Deposit8"), [
            `<span class="num">${this.chargeCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.money,
              this.userAccuracy
            )}</span>`,
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount,
              this.userAccuracy
            )}</span>`,
          ]);
          txt3 = formatLang(this.$t("Datalang.newly_Complete_now"), [
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount2,
              this.userAccuracy
            )}</span>`,
          ]);
          txt4 = formatLang(this.$t("Datalang.newly_Remaining7"), [`<span class="num">${this.formattedTime}</span>`]);
          txt5 = this.$t("Datalang.newly_No_deduction");
          break;
        case "3":
          txt0 = this.$t("Datalang.newly_Weekly_Card9");
          txt1 = this.$t("Datalang.newly_Weekly_Card9");
          txt2 = formatLang(this.$t("Datalang.newly_This_payment"), [
            `<span class="num">${this.chargeCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.money,
              this.userAccuracy
            )}</span>`,
          ]);
          txt3 = formatLang(this.$t("Datalang.newly_Pay_to"), [
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount,
              this.userAccuracy
            )}</span>`,
          ]);
          txt4 = formatLang(this.$t("Datalang.newly_Total25"), [
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.zongRewardValue,
              this.userAccuracy
            )}</span>`,
          ]);
          // txt5 = formatLang(this.$t('Datalang.newly_Wagering_multiple'), [`<span class="num">${}</span>`])
          break;
        case "4":
          txt0 = this.$t("Datalang.newly_Special_Deposit");
          txt1 = this.$t("Datalang.newly_Special_Deposit");
          txt2 = formatLang(this.$t("Datalang.newly_Deposit8"), [
            `<span class="num">${this.chargeCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.money,
              this.userAccuracy
            )}</span>`,
            `<span class="num">${this.userCoinSymbol} ${this.divideAccuracy(
              this.waitRechargeObj.activityAmount,
              this.userAccuracy
            )}</span>`,
          ]);
          // txt3 =
          // txt4 = formatLang(this.$t('Datalang.newly_Wagering_multiple'), [`<span class="num">${}</span>`])
          break;
      }
      return {
        txt0,
        txt1,
        txt2,
        txt3,
        txt4,
        txt5,
        timeDown: this.formattedTime,
      };
    },
    formattedTime() {
      const sec = this.tipType === "2" ? this.remainingSeconds1 : this.remainingSeconds;
      const h = Math.floor(sec / 3600)
        .toString()
        .padStart(2, "0");
      const m = Math.floor((sec % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const s = (sec % 60).toString().padStart(2, "0");
      return `${h}:${m}:${s}`;
    },
    hasTopNavigation() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5?.center === 2 && this.getIsMobile;
    },
    maintain() {
      // console.log(this.$store.state.auth.maintain, "this.$store.state.auth.maintain;=======");
      return this.$store.state.auth.maintain;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    isLogin() {
      return this.$store.getters.login;
    },
    userData() {
      return this.$store.getters.user;
    },
    userAccuracy() {
      return this.userData.accuracy;
    },
    userCoinSymbol() {
      return this.userData.coinSymbol;
    },
    coinList() {
      return this.$store.getters.getPacketConfig?.coinList || [];
    },
    chargeCoinSymbol() {
      const obj = this.coinList.find((i) => i.coinCode === this.waitRechargeObj.coinCode) || {};
      return obj.symbol;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    user() {
      return this.$store.getters.user;
    },
    loginObj() {
      const isLogin = this.$store.getters.login;
      const defaultCoinCode = JSON.parse(JSON.stringify(localStorage.getItem("defaultCoinCode")));
      const after_quick = JSON.parse(JSON.stringify(localStorage.getItem("after_quick")));
      const selectCoin = this.$store.state.auth.selectCoin;
      return { isLogin, defaultCoinCode, after_quick, selectCoin };
    },
    taken() {
      return this.$store.getters.taken;
    },
    displayPromoteUrl() {
      // 是否展示邀请
      // return this.$store.getters.getDisplayPromoteUrl === 'ROW_STATUS_ENABLE'
      return true;
    },
  },
  methods: {
    safeTriggerRechargeDetail() {
      const now = Date.now();
      if (now - this.lastTriggerTime < 1000) return; // 1秒内不重复执行
      this.lastTriggerTime = now;

      this.getWaitRechargeOrderDetailFun();
    },
    getWaitRechargeOrderDetailFun() {
      if (!this.taken) {
        return false;
      }
      getWaitRechargeOrderDetail().then((res) => {
        if (res.code === 0) {
          this.waitRechargeObj = res.data?.detail || {};
          const activityType = this.waitRechargeObj.activityType;
          const purchaseType = this.waitRechargeObj.purchaseType;
          const arr1 = ["ActivityTypeFirstRecharge", "ActivityTypeRepeatRecharge", "ActivityTypeLimitedtimeDiscount"];
          const arr2 = ["ActivityTypeWeekMonthCard"];
          if (purchaseType === "PURCHASE_TYPE_RECHARGE_GIFT") {
            this.tipType = "4";
            this.showFloatingFun();
          } else if (arr2.includes(activityType)) {
            this.tipType = "3";
            this.showFloatingFun();
          } else if (
            this.waitRechargeObj.activityAmount2 &&
            Number(this.waitRechargeObj.activityAmount2) !== 0 &&
            Number(this.waitRechargeObj.expireTime) > 0
          ) {
            this.tipType = "2";
            this.waitRechargeObj.activityType = "ActivityTypeRechargeTurntable";
            this.remainingSeconds1 = this.waitRechargeObj.expireTime ? Number(this.waitRechargeObj.expireTime) : 0;
            this.showFloatingFun();
          } else if (arr1.includes(activityType) || purchaseType === "PURCHASE_TYPE_BANKRUPT_GUIDE") {
            this.tipType = "1";
            this.showFloatingFun();
          } else {
            this.showFloating = false;
            this.showDialog = false;
          }
        }
      });
    },
    showFloatingFun() {
      this.showFloating = true;
      this.$eventPost("order_retrieval_floating_popup", {
        SubActivityType: this.waitRechargeObj.activityType,
        SubPurchaseType: this.waitRechargeObj.purchaseType,
      });
      this.startCountdown();
    },
    showDialogFun() {
      this.$eventPost("order_retrieval_floating_payment", {
        SubActivityType: this.waitRechargeObj.activityType,
        SubPurchaseType: this.waitRechargeObj.purchaseType,
      });
      this.showDialog = true;
      this.$eventPost("order_retrieval_popup", {
        SubActivityType: this.waitRechargeObj.activityType,
        SubPurchaseType: this.waitRechargeObj.purchaseType,
      });
    },
    startCountdown() {
      this.clearTimer();
      this.timer = setInterval(() => {
        // 判断是哪种类型
        if (this.tipType === "2") {
          // tipType = 2 时，用 remainingSeconds1 倒计时，结束后隐藏悬浮栏
          if (this.remainingSeconds1 > 0) {
            this.remainingSeconds1--;
          } else {
            this.clearTimer();
            this.showFloating = false; // 倒计时结束隐藏悬浮栏
            this.showDialog = false;
          }
        } else {
          // tipType = 1/3/4 时，用 remainingSeconds 倒计时，结束后重新开始
          if (this.remainingSeconds > 0) {
            this.remainingSeconds--;
          } else {
            this.remainingSeconds = 30 * 60; // 重新开始倒计时
          }
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleCancal(type) {
      this.showDialog = false;
      if (type === "btn") {
        this.$eventPost("order_retrieval_popup_quit_discount", {
          SubActivityType: this.waitRechargeObj.activityType,
          SubPurchaseType: this.waitRechargeObj.purchaseType,
        });
      } else {
        this.$eventPost("order_retrieval_popup_close", {
          SubActivityType: this.waitRechargeObj.activityType,
          SubPurchaseType: this.waitRechargeObj.purchaseType,
        });
      }
    },
    handleConfirm() {
      if (this.confirmLoading) return;
      this.confirmLoading = true;
      this.$eventPost("order_retrieval_popup_payment", {
        SubActivityType: this.waitRechargeObj.activityType,
        SubPurchaseType: this.waitRechargeObj.purchaseType,
      });
      this.$Bus.$emit("commonChargeShow", {
        commonLoading: true,
      });
      userSecondRecharge({ orderNumber: this.waitRechargeObj.orderNumber })
        .then((res) => {
          this.$Bus.$emit("commonChargeShow", {
            commonLoading: false,
          });
          if (res.code === 0) {
            this.showDialog = false;
            this.getWaitRechargeOrderDetailFun();
            this.$Bus.$emit("commonChargeShow", {
              isUserSecondRecharge: true,
              res: res, // 二次充值返回的数据
            });
          }
        })
        .finally(() => {
          // 1.5秒后允许再次点击（防止网络慢导致多点）
          setTimeout(() => {
            this.confirmLoading = false;
          }, 1500);
        });
    },
    getTipsStatus() {
      withdrawGuideShowText().then((res) => {
        if (res.code === 0) {
          const enableExchangeTips = res.data.show === "ROW_STATUS_ENABLE";
          this.$store.commit("setEnableExchangeTips", enableExchangeTips);
        }
      });
    },
    goShare() {
      if (!this.$store.getters.taken) {
        this.$Bus.$emit("showLogin");
        return;
      }
      this.$eventPost("notice_popup_share");
      this.$popConfig.endWinConfig();
      this.$isPopShow({
        show: true,
        views: "ShareCode",
        fullscreen: false,
        data: {
          title: this.$t("Datalang.treasure_Quick_Share"),
          width: "700px",
        },
      });
    },
    // homeScrollTop(opt = {}) {
    //   this.isFixed = opt.scrollTop > 175;
    //   this.topValue = opt.showDown ? 80 : 40;
    // },
    initScroll() {
      if (this.isLogin) {
        return;
      }
      // 获取用户是否第一次滑动
      this.firstScroll = localStorage.getItem("firstScroll") || "";
      this.firstScrollBottom = localStorage.getItem("firstScrollBottom") || "";
      if (!this.firstScroll || !this.firstScrollBottom) {
        // 添加滚动事件监听
        this.listenscroll = true;
        window.addEventListener("scroll", this.handleScroll);
      } else {
        this.listenscroll = false;
      }
    },
    // 定义处理滚动事件的函数
    handleScroll() {
      // 获取当前滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (!this.firstScroll && scrollTop > 0) {
        this.$eventPost("screen_slide_scale", { slide_value: "hd" });
        this.firstScroll = true;
        localStorage.setItem("firstScroll", "true");
      }
      const viewportHeight = window.innerHeight;
      const mainBox = document.getElementById("mainBox");
      // console.log(mainBox.offsetHeight, viewportHeight + scrollTop);
      const pageHeight = mainBox?.offsetHeight;
      // 当前滚动位置加上视窗高度 是否 大于 页面高度
      if (!this.firstScrollBottom && scrollTop + viewportHeight >= pageHeight) {
        console.log("====首次滚动start=======");
        this.$eventPost("screen_slide_scale", { slide_value: "hddb" });
        this.firstScrollBottom = true;
        localStorage.setItem("firstScrollBottom", "true");
      }
      if (this.firstScroll && this.firstScrollBottom) {
        console.log("====滚动到底部end=======");
        this.listenscroll = false;
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
    onRadioChange(val) {
      if (val) {
        const day = new Date().Format("yyyy-MM-dd");
        localStorage.setItem("isShowEvents", day);
      } else {
        removeLocalStorage("isShowEvents");
      }
    },
    // 关闭弹窗
    close(flag) {
      if (!flag) {
        // 点击按钮关闭弹窗 不进行打点
        const item = this.list[0] || {};
        this.$eventPost("tpgn_notice_close", {
          pop_type: item.dialogType,
          name: item.name || "",
          ruleName: item.ruleName || "",
          ruleSid: item.ruleSid || "",
        });
      }
      const day = new Date().Format("yyyy-MM-dd");
      if (this.taken) {
        localStorage.setItem("evryDayEvent", day);
        localStorage.setItem("evryLoginEvent", day);
      }
      if (!flag) this.$popConfig.winConfigNext();
      this.showEventModal = false;
    },
    closeActivityDialog(flag) {
      if (!flag) this.$popConfig.winConfigNext();
      this.showActivityDialog = false;
    },
    // 标签跳转
    clickFun() {
      this.$Bus.$emit("showLogin", { tab: "Login" });
    },
    clickFunx() {
      this.$Bus.$emit("showLogin", { tab: "Register" });
    },

    toLogin() {
      this.$Bus.$emit("showLogin", { tab: "Login" });
    },
    toCharge() {
      if (!this.$store.getters.taken) {
        this.$Bus.$emit("showLogin");
        return;
      }
      this.$Bus.$emit("showCharge", { show: true });
    },
    toExchange() {
      if (!this.$store.getters.taken) {
        this.$Bus.$emit("showLogin");
        return;
      }
      this.$Bus.$emit("showExchange", { show: true });
    },
    toHistory() {
      this.$router.push("/history");
    },
    toVip() {
      if (!this.$store.getters.taken) {
        this.$Bus.$emit("showLogin");
        return;
      }
      this.$router.push("user/hvip");
    },
    // 处理是否显示公告弹窗
    showAnnouncementModal(data) {
      this.list = data.list || [];
      this.showEventModal = data.show;
    },
    // 处理是否显示活动弹窗
    showActivityModal(data) {
      console.log("activityList", data);
      this.activityList = data.list || [];
      this.showActivityDialog = data.show;
    },
    hideNoticeModal() {
      this.showEventModal = false;
      this.showActivityDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.floatingBar {
  font-size: 12px;
  position: fixed;
  right: 10px;
  top: 110px;
  background: var(--background-401);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 5px 10px 5px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 9999;
  ::v-deep .num {
    color: var(--font-color-300);
  }
  .floatingBarRight {
    .floatingBarClose {
      font-size: 16px;
      position: absolute;
      cursor: pointer;
      top: 1px;
      left: 1px;
    }
    .timeDown {
      color: var(--font-color-100);
      margin-bottom: 3px;
      text-align: center;
    }
  }
}
.tipDialog {
  ::v-deep .num {
    color: var(--font-color-300);
  }
  ::v-deep .el-dialog {
    overflow: visible;
    margin-top: 35vh !important;
    .el-dialog__header {
      padding: 0;
      .title-box {
        height: 0;
        border-bottom: none;
        .close {
          top: -40px;
          z-index: 2;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
    }
    .txtMain {
      text-align: center;
      line-height: 24px;
      position: relative;
      padding: 60px 0 20px;
      .tipHead {
        position: absolute;
        top: 0; /* 往上移动50px，具体可调整 */
        left: 0%;
        width: 100%; /* 根据图片调整宽度 */
        z-index: 1; /* 保证在弹窗内容上层 */
        transform: scale(1.1) translateY(-65%);
        .tipHeadImg {
          width: 100%;
        }
        .tipTitle {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          width: 100%;
          text-align: center;
          bottom: 17%;
          z-index: 1;
          height: 18%;
          font-size: 16px;
          color: var(--font-color-200);
        }
      }
      .tipContent {
        margin: 0px 15px;
        padding: 10px;
        background: var(--background-801);
        border-radius: var(--radius-100);
        .tipAmountImg {
          width: 67px;
        }
        .times {
          display: flex;
          justify-content: center;
          align-items: center;
          .gameIcon {
            margin-top: 10px;
            width: 80px;
            border-radius: var(--radius-100);
          }
        }
      }
    }
    .btnDom {
      padding-bottom: 20px;
      .btn-unfinished {
        background: var(--button-350);
        box-shadow: var(--boxShadow-350);
        color: var(--font-color-100);
      }
    }
  }
}
.displayPromoteUrlDom {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 10px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  .invitaTxt {
    color: var(--font-color-900);
    margin-right: 10px;
  }
  .invitaBtn {
    @include buttonYellow;
  }
}
.event-modal_box {
  font-size: 16px;
  transform: translateY(20px);
  max-width: 800px;
  margin: 0 auto;
  .radio {
    text-align: center;
    margin-top: 10px;
    padding-bottom: 12px;

    .el-checkbox {
      color: var(--font-color-400);
    }

    ::v-deep .el-radio__label {
      font-size: 16px;
    }
  }
}

.tagDiv {
  overflow: hidden;
  margin-bottom: 16px;

  .tagClearFloat {
    float: left;
    background: #000000;
    line-height: 36px;
    border-radius: 22px;
    -webkit-border-radius: 22px;
    -moz-border-radius: 22px;
    -ms-border-radius: 22px;
    -o-border-radius: 22px;
    padding: 4px 4px;
  }

  .tagBtn {
    position: relative;
    float: left;
    height: 36px;
    line-height: 34px;
    border-radius: 18px;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
    // background: #1A242D;
    padding: 0 10px;
    margin: 0 5px;
    cursor: pointer;
    font-size: 14px;
  }

  .tagBtn:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 12px;
    right: -5px;
    width: 1px;
    height: 12px;
    background: #fff;
  }

  .tagBtn:hover {
    background: #1a242d;
  }
}

.game-type-box {
  width: 100%;
  padding-top: 21px;
  color: var(--font-color-100);

  .game-type {
    position: relative;
    display: inline-block;
    min-width: 60px;
    height: 42px;
    padding: 0 16px 0 50px;
    margin-bottom: 16px;
    margin-right: 16px;
    line-height: 42px;
    border-radius: 30px;
    background: var(--background-300);
    cursor: pointer;

    &:hover {
      transition: 0.5s;
      background: var(--font-color-800);
    }

    & > .sprite-icon {
      left: 14px;
    }

    &.on {
      background: var(--font-color-800);
    }
  }
}

.infoDiv {
  border-bottom: 1px solid #ccc;
}

.info {
  padding: 10px 0px 10px;

  .left {
    line-height: 18px;
    margin-top: 5px;

    .beforeLogin {
      max-width: 85px;
      word-break: break-all;
    }

    .name {
      font-size: 16px;
      color: #133ea1;
      max-width: 85px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .vip {
      font-size: 12px;
      color: #666;
    }
  }

  .right {
    font-size: 12px;
    color: #133ea1;

    .rightCon {
      width: 63px;

      div {
        margin: 2px 0 0 0;
        text-align: center;
      }
    }

    img {
      display: block;
      height: 30px;
      margin: 0 auto;
      margin-bottom: 0px;
    }
  }
}

.z-button2 {
  height: 30px;
  line-height: 28px;
  margin-top: 10px;
  font-size: 14px;
}

.isFixed {
  position: fixed;
  background: #fff;
  z-index: 1000;
  width: 100%;
  left: 0;
  padding: 9.2px 10px 0 10px;
  box-sizing: border-box;
  box-shadow: 0px 3px 5px 0px #ddd;
}

.blankContent {
  width: 100%;
  height: 100px;
}
</style>
